export const contactSupport = {
  support_title_message: "Contact us and we will solve it together!",
  support_message: "Questions? Message us on WhatsApp or email. We're here to help.",
  support_modal_email: "Email",
};
